<pf-listview [items]="filteredDiscountedProducts!"
    [title]="('products.order.discountedProducts' | translate | uppercase)" [hasSearchSection]="true"
    [searchPlaceholder]="'Szerző, cím neve'" [useDragDrop]="true" [useSaveButton]="true"
    [saveButtonText]="('admin.save' | translate | uppercase)" (save)="updateDiscountedProductsOrder()">
    <ng-template #itemTemplate let-product let-i="index">
        <div class="banner-row-layout">
            <div class="name-link">
                <div class="product-info">
                    @if (product.routerLink !== 'morte_taska') {
                    <span class="product-title">
                        <strong>{{ product.author }}</strong> : {{ product.title }}
                    </span>
                    }

                    @if (product.quantityOfSupply! > 0) {
                    <span class="stock-info">
                        / {{ product.quantityOfSupply }} db
                    </span>
                    }
                </div>
            </div>
        </div>
    </ng-template>
</pf-listview>
